// extracted by mini-css-extract-plugin
export default {"root":"FloFormGroup_root__iAkrJ","errorMessage":"FloFormGroup_errorMessage__W0EYV","label":"FloFormGroup_label__Dpabv"};